module.exports = __webpack_public_path__ + "img/shin.2636b25e.png";